import { render, staticRenderFns } from "./myRoomsixth.vue?vue&type=template&id=37ece8b9&scoped=true"
import script from "./myRoomsixth.vue?vue&type=script&lang=js"
export * from "./myRoomsixth.vue?vue&type=script&lang=js"
import style0 from "./myRoomsixth.vue?vue&type=style&index=0&id=37ece8b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ece8b9",
  null
  
)

export default component.exports